/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodTypeSchema = z.enum(['wallet', 'invoice', 'stripe'])

export type PaymentMethodTypeSchema = z.infer<typeof paymentMethodTypeSchema>
